import React, { Fragment, useState } from "react";
import { useQueryClient } from "react-query";
import { Spinner } from "reactstrap";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Button from "../../components/Button/Button";
import AddIncomeDialog from "../../components/Dialog/AddIncomeDialog";
import ConfirmDialog from "../../components/Dialog/ConfirmDialog";
import Loading from "../../components/Loadings/LoadingTable";

// components
import { Table } from "../../components/Table/Table";

// HOC
import withToggle from "../../HOC/withToggle";
import { useDeleteIncome, useGetIncome } from "../../hooks/useAccounting";

// styled components
import { Container } from "../../theme/GlobalStyle";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import { separate } from "../../utils/separate";
import { Row } from "../AnbarPage/anbarStyle";

// component Content
const Content = ({ toggleShowModal }) => {
  return (
    <Row>
      <Button
        small="100px"
        bgColor="#0062FF"
        color="#fff"
        onclick={toggleShowModal}
      >
        درج درآمد
      </Button>
    </Row>
  );
};

const IncomePage = ({
  isToggle,
  toggleHideModal,
  toggleShowModal,
  reports,
}) => {
  const [update, setUpdate] = useState({});
  const [Search, setSearch] = useState("");
  const [isShowDelete, setIsShowDelete] = useState(false);
  const [selectId, setSelectId] = useState("");
  const queryClient = useQueryClient();
  // react query get list
  const { data, isLoading } = useGetIncome();
  const revenues = data?.data?.revenues;
  // react query delete income
  const { mutateAsync: deleteIncome, isLoading: loadingDelete } =
    useDeleteIncome();
  const headerTitle = !reports
    ? [
        "#",
        "نام",
        "کد",
        "قیمت پیش فرض",
        "مبلغ",
        "توضیحات",
        "دسته بندی",
        "تاریخ ",
        "ویرایش",
        "حذف",
      ]
    : ["#", "نام", "مبلغ"];

  const handleDeletePurchaseItem = async () => {
    await deleteIncome(selectId);
    queryClient.invalidateQueries("income-list");
    setIsShowDelete(false);
    // toggleHideModal();
  };

  const items = revenues
    ?.filter((items) => {
      if (Search === "") {
        return items;
      } else if (items?.NameRevenues.includes(Search)) {
        return items;
      }
    })
    ?.map((item, index) => (
      <tr key={item?.IdRevenues}>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {index + 1}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {item?.NameRevenues}
          </span>
        </td>
        {!reports ? (
          <>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.IdRevenues}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {separate(item?.DefaultPriceRevenues)}
              </span>
            </td>
          </>
        ) : (
          ""
        )}
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {separate(item?.PriceRevenues)}
          </span>
        </td>
        {!reports ? (
          <>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.DescriptionRevenues}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {item?.GroupingRevenues}
              </span>
            </td>
            <td>
              <span className="text-muted fw-bold text-muted d-block fs-7">
                {MiladiToShamsi(item?.created_at)}
              </span>
            </td>
            <td>
              <Button
                size="12px"
                bgColor="#0D6EFD"
                small="100px"
                color="#fff"
                onclick={() => {
                  setUpdate(item);
                  toggleShowModal();
                }}
              >
                ویرایش{" "}
              </Button>
            </td>
            <td>
              <Button
                size="12px"
                bgColor="#DC3545"
                small="100px"
                color="#fff"
                onclick={() => {
                  setIsShowDelete(true);
                  setSelectId(item?.IdRevenues);
                }}
              >
                حذف
              </Button>
            </td>
          </>
        ) : (
          ""
        )}
      </tr>
    ));

  if (isLoading) {
    return <Loading />;
  }
  return (
    <Fragment>
      {!reports ? (
        <BreadCrumb
          margin="mt-3"
          num1="واحد حسابداری"
          num2="اطلاعات پایه"
          num3="درآمدها"
        />
      ) : (
        <BreadCrumb
          margin="mt-3"
          num1="واحد حسابداری"
          num2="گزارشات"
          num3="درآمدها"
        />
      )}
      <Container>
        <Table
          title={`لیست درامد ها (${items?.length})`}
          headerTitle={headerTitle}
          // addCheckDesk={<AddCheckDesk toggleShowModal={toggleShowModal} />}
          items={items}
          setSearch={setSearch}
          // content={<Content toggleShowModal={toggleShowModal} />}
          scroll
          addCheck={
            <Button
              small
              bgColor="#0062FF"
              color="#fff"
              onclick={toggleShowModal}
            >
              اضافه کردن
            </Button>
          }
        />
      </Container>
      {isToggle && (
        <AddIncomeDialog
          toggleHideModal={() => {
            toggleHideModal();
            setUpdate({});
          }}
          show={isToggle}
          update={update}
        />
      )}
      {isShowDelete && (
        <ConfirmDialog
          title="آیا از حذف این مورد مطمئن هستید ؟"
          show={isShowDelete}
          handleClose={() => setIsShowDelete(false)}
          successTitle={
            loadingDelete ? (
              <Spinner animation="border" variant="light" color="light" />
            ) : (
              "تایید"
            )
          }
          feildTitle="منصرف شدم"
          onFeild={() => setIsShowDelete(false)}
          onSuccess={handleDeletePurchaseItem}
        />
      )}
    </Fragment>
  );
};
export default withToggle(IncomePage);
